import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  textInput: {
    width: "270px"
  },
  bottomComponentsContainer: {
    padding: spacing(5, 5, 3)
  }
}))
